<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="white" dark v-bind="attrs" v-on="on" @click="buildUrl">
          <v-icon class="grey--text">mdi-qrcode</v-icon>
        </v-btn>
      </template>
      <v-card>
        <img :src="fullUrl" alt="" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'CassQRcode',
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    }
  },
  data() {
    return {
      dialog: false,
      p: 'https://www.google.com/maps/place/',
      url: '',
      fullUrl: '',
      cord: [],
      direction: []
    }
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    }
  },
  methods: {
    buildUrl: function () {
      this.cord = this.orderDetail.customer.location.cord
      this.direction = this.cord.latitude + ',' + this.cord.longitude
      this.fullUrl =
        'https://chart.googleapis.com/chart?cht=qr&chs=' +
        300 +
        'x' +
        300 +
        '&chl=' +
        encodeURIComponent(this.p) +
        this.direction
    }
  }
  // computed: {
  //   orderDetail() {
  //     if (this.documentId) {
  //       return this.$store.getters['order/orderAfterFilter'].filter(
  //         (order) => order.documentId === this.documentId
  //       )[0]
  //     } else {
  //       return this.$store.state.order.sample[0]
  //     }
  //   }
  // },
  // methods: {
  //   buildUrl: function () {
  //     this.cord = this.orderDetail.customer.location.cord
  //     console.log(this.orderDetail.customer.location.cord)
  //     this.direction = this.cord.latitude + ',' + this.cord.longitude
  //     this.fullUrl =
  //       'https://chart.googleapis.com/chart?cht=qr&chs=' +
  //       300 +
  //       'x' +
  //       300 +
  //       '&chl=' +
  //       encodeURIComponent(this.p) +
  //       this.direction
  //   }
  // }
}
</script>

<style scoped></style>
